<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5nFzUV/tc-custom/9781453252949.jpg?1728353212155" alt="This image is the cover for the book Not Long for This World, The Aaron Gunner Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Not Long for This World, The Aaron Gunner Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A lawyer hires Gunner to help her prove that her gangland client is not a killer</b>Darrel Lovejoy doesn’t owe South Central anything. By all accounts, he is lucky to escape this desperate corner of Los Angeles, to go to college and graduate into a well-paid advertising job. But something compels him to return. He dives into social work, attempting to mediate between the gangs which have brought hell to the streets he grew up on, and he makes slow but steady progress up until the day a shotgun blast cuts him down. After an unusually forthcoming witness swears she saw a car of Imperial Blues kill Lovejoy, the police arrest Blue soldier Toby Mills. Suspecting a frame-up, Toby’s lawyer hires private detective Aaron Gunner to vet the woman’s story. To find out why South Central’s favorite son had to die, Gunner will turn gangland upside down.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gar Anthony Haywood
      </h2>
      
      <p class="authorDescription body article">Gar Anthony Haywood (b. 1954) is the Shamus Award&ndash;winning author of the Aaron Gunner mysteries. Born in Los Angeles, he spent over a decade as a computer technician before first publishing fiction in the 1980s. Influenced by a love for the Los Angeles mysteries of Ross Macdonald, he wrote <i>Fear of the Dark</i> (1987), winning the Shamus Award for best first novel and introducing the tough-nosed Los Angeles detective Aaron Gunner.&#160;Haywood continued the Gunner series through the bestselling <i>All the Lucky Ones Are Dead</i> (2000), and in between Gunner novels produced the two-book Loudermilk pair of seriocomic mysteries. Haywood also wrote two stand-alone thrillers, <i>Man Eater</i> (2003) and <i>Firecracker</i> (2004), under the pseudonym Ray Shannon, finding critical acclaim for both. He has written for newspapers and television, including an adaptation of the Dennis Rodman autobiography, <i>Bad as I Wanna Be</i>. His most recent novels are <i>Cemetery Road</i> (2010) and <i>Assume Nothing</i> (2011).<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?021a31d7